import { Component, Input, ViewChild, ElementRef } from '@angular/core';

import { Rodeo } from '../../../../model/rodeo';
import { RodeoEventRun } from '../../../../model/rodeoEventRun';
import { RunService } from '../../../../services/run.service';
import { LoadingController, ToastController, ViewController } from 'ionic-angular';
import { ImageService } from '../../../../services/image.service';
import { RodeoService } from '../../../../services/rodeo.service';
import { AlertMessager } from '../../../../lib/alertMessager';
import { File } from '@ionic-native/file';
import { Photo } from '../../../../model/photo';

@Component({
    selector: 'staff-photo-upload',
    templateUrl: 'photo-upload.html'
})
export class PhotoUploadSection {
    @ViewChild('runContainer') runContainer: ElementRef;
    _rodeo: Rodeo;
    _viewMode: string;

    startedTimers: boolean;
    stopTimers: boolean;

    priceChanged: boolean;

    popoverActive: boolean;

    loggedRuns: RodeoEventRun[] = [];

    eventTypeMapping: Map<any, any> = new Map();

    purchasedPhotos: Photo[] = [];

    @Input()
    set rodeo(rodeo: Rodeo) {
        if (rodeo != null) {
            this._rodeo = rodeo;

            this._rodeo.rodeoEvents.forEach((rodeoEvent) => {
                if (rodeoEvent.eventType === 'BullRiding' || rodeoEvent.eventType === 'SaddleBroncRiding' || rodeoEvent.eventType === 'RanchBroncRiding'
                || rodeoEvent.eventType === 'BarebackRiding')
                    rodeoEvent.roughStock = true;

                rodeoEvent.schedules.forEach(schedule => {
                    this.eventTypeMapping[schedule.id] = rodeoEvent.eventType;
                });
            });
        }
    }
    get rodeo(): Rodeo {
        return this._rodeo;
    }

    @Input()
    set viewMode(viewMode: string) {
        if (viewMode != null) {
            this._viewMode = viewMode;
        }
    }
    get viewMode(): string {
        return this._viewMode;
    }

    constructor(private runService: RunService, private toast: ToastController, private viewController: ViewController, private alertMessager: AlertMessager, private file: File,
        private loader: LoadingController, private imageService: ImageService, private rodeoService: RodeoService, private toastController: ToastController) { }

    startTimers() {
        if (this.startedTimers)
            return;

        this.getUpdatedRuns();
        this.startedTimers = true;
    }

    stopTimerLoops() {
        this.stopTimers = true;
    }

    onInput($event:any) {
        let theEvent = $event || window.event,
            key = theEvent.target.value,
            regex = /[0-9]+/g;

        if( !regex.test(key) ) {
            let resp = $event.target.value.match(regex)
            $event.target.value = resp ? resp.join('')  : '';
        }

        this.priceChanged = true;
    }

    getUpdatedRuns() {
        let runUpdateInfo = [];

        this.loggedRuns.forEach((run) => {
            runUpdateInfo.push({ Id: run.id, Updated: run.updated });
        });

        this.runService.getCompletedEventRuns(this.rodeo.id, runUpdateInfo)
        .then (data => {
            (data as any).update.forEach(run => {                
                for (let y = 0; y < this.loggedRuns.length; y++) {
                    if (this.loggedRuns[y].id == run.id) {
                        this.setDisplayValue(run);
                        Object.assign(this.loggedRuns[y], run);  

                        if (run.photos != null) {
                            let purchasedPhotos = run.photos.filter(x => x.purchased);

                            if (purchasedPhotos != null && purchasedPhotos.length > 0) {
                                purchasedPhotos.forEach((photo) => {
                                    if (!this.purchasedPhotos.some(x => x.id == photo.id)) {
                                        photo.run = run;
                                        this.purchasedPhotos.push(photo);
                                    }
                                });
                            }
                        }
                    }
                }             
            });

            (data as any).delete.forEach(run => {
                this.loggedRuns = this.loggedRuns.filter(x => x.id != run.id);             
            });

            (data as any).add.forEach(run => {
                this.setDisplayValue(run);
                this.loggedRuns.push(run);

                if (run.photos != null) {
                    let purchasedPhotos = run.photos.filter(x => x.purchased);

                    if (purchasedPhotos != null && purchasedPhotos.length > 0) {
                        purchasedPhotos.forEach((photo) => {
                            if (!this.purchasedPhotos.some(x => x.id == photo.id)) {
                                photo.run = run;
                                this.purchasedPhotos.push(photo);
                            }
                        });
                    }
                }
            });

            this.loggedRuns.sort((a, b) => {
                if (a.updated > b.updated)
                    return -1;
                else if (a.updated < b.updated)
                    return 1;
                else 
                    return 0;
            });

            this.refreshUpdateRuns();
        }, error => {
            this.refreshUpdateRuns();
        });
    }

    refreshUpdateRuns() {
        setTimeout(() => {
            if (this.viewController.isLast())
                this.getUpdatedRuns();
        }, 100);
    }

    async fileChange(fileList, run: RodeoEventRun) {
        if (fileList) {
            let error = "";

            console.log("run: ", run);

            const loader = this.loader.create({content: 'Uploading Photo ' + 1 + " of " + fileList.length + "..."});
            await loader.present();

            for (let index = 0; index < fileList.length; index++) {   
                let file = fileList.item(index);             
                loader.setContent('Uploading Photo ' + (index + 1) + " of " + fileList.length + "...");
                let filename = run.id.toString() + '_' + ((run.photos != undefined ? run.photos.length : 0) + index + 1) + '.' + file.name.split('.').pop();

                try
                {
                    var photo = await this.imageService.uploadRunPhoto(file, filename, run.id);

                    if (run.photos == undefined)
                        run.photos = [];
                    
                    run.photos.push(photo);
                }
                catch (err)
                {
                    error = 'Photos upload issue: ' + err;
                    console.log('Photos upload issue: ', err);
                }

                if (error == "") {
                    await this.toast.create({
                        message: 'Photos Uploaded Successfully!',
                        showCloseButton: true,
                        duration: 3000
                    }).present();
                }
            }

                            
            await loader.dismiss();
        }
    }

    async updatePhotoPrice() {
        const loader = this.loader.create({content: 'Updating Photo Price...'});
        await loader.present();

        this.rodeoService.updateRodeoPhotoPrice(this.rodeo.id, this.rodeo.defaultPhotoPrice)
        .then(data => {
            if ((data as any).errorMessage !== undefined)
                this.alertMessager.showError("Update Error", (data as any).errorMessage);
            else {
                this.toastController.create({
                    message: "Photo Price saved!",
                    duration: 3000,
                    position: 'middle',
                }).present();
            }
            loader.dismiss();
        }, error => {
            this.alertMessager.showError("Rodeo Update Error", error);
            loader.dismiss();
        });
    }

    isRoughStock(eventType) {
        if (eventType === 'BullRiding' || eventType === 'SaddleBroncRiding' || eventType === 'RanchBroncRiding' || eventType === 'BarebackRiding')
            return true;
        else
            return false;
    }

    getFirstLabel(run : RodeoEventRun) {
        let eventType = this.eventTypeMapping[run.rodeoEventScheduleId];
        switch (eventType) {
            case 'TeamRoping':
                return 'Header';
            default:
                return 'Rider';            
        }
    }

    getSecondDisplay(run : RodeoEventRun) {
        let eventType = this.eventTypeMapping[run.rodeoEventScheduleId];

        switch (eventType) {
            case 'TeamRoping':
                return run.contestantTwo.firstName + ' ' + run.contestantTwo.lastName;
            case 'BarrelRacing':
                if (run.horseOne == null)
                    return "Horse 1";
                else
                    return run.horseOne.name;            
            default:
                if (run.livestock == null)
                    return "Livestock 1";
                else
                    return run.livestock.brand + ' ' + run.livestock.name;
        }
    }

    getSecondLabel(run : RodeoEventRun) {
        let eventType = this.eventTypeMapping[run.rodeoEventScheduleId];
        switch (eventType) {
            case 'TeamRoping':
                return 'Heeler';
            case 'BarrelRacing':
                return 'Horse';            
            default:
                return "Livestock";
        }
    }

    getRunValue(run : RodeoEventRun, total: boolean = false) {
        let eventType = this.eventTypeMapping[run.rodeoEventScheduleId];
        if (!total)
        {
            if (run.noTime)
                return this.isRoughStock(eventType) ? "NS" : "NT";

            if (run.turnedOut)
                return "TO";
        }

        let extraOnDisplay = ' on ' + run.displaySuccessfulRuns;

        if (this.isRoughStock(eventType)) {
            if (run.done)
                return !total ? run.score : run.totalScore + extraOnDisplay;
            else
                return run.score;
        }
        else
        {
            var timeString = "";

            if (run.done)
                timeString = (!total ? run.time : run.totalTime).toString();
            else
                timeString = run.time.toString();

            var periodIndex = timeString.indexOf(".");

            if (periodIndex == -1)
                timeString += ".";

            let zeroCount = timeString.length - 1 - timeString.indexOf(".");
            let decimalPlaces = 3;

            if (eventType.indexOf('Barrel') == -1)
                decimalPlaces--;

            if (eventType.indexOf('Wrestling') != -1)
                decimalPlaces--;

            while (decimalPlaces - zeroCount > 0) {
                timeString += "0";
                zeroCount++;
            }

            if (zeroCount > decimalPlaces) {
                timeString = timeString.toString().substring(0, periodIndex + 3);
            }

            if (run.done && total)
                timeString += extraOnDisplay;

            return timeString;
        }
    }

    setDisplayValue(run: RodeoEventRun) {
        let eventType = this.eventTypeMapping[run.rodeoEventScheduleId];
        
        if (!run)
            return;

        if (run.noTime)
            run.displayValue = this.isRoughStock(eventType) ? "NS" : "NT";
        else {
            if (this.isRoughStock(eventType)) {
                 run.displayValue = run.score;
            } else {
                var timeString = run.time.toString();
                var periodIndex = timeString.indexOf(".");
    
                if (periodIndex == -1)
                    timeString += ".";
    
                let zeroCount = timeString.length - 1 - timeString.indexOf(".");
                let decimalPlaces = 3;
    
                if (eventType.indexOf('Barrel') == -1)
                    decimalPlaces--;
    
                if (eventType.indexOf('Wrestling') != -1)
                    decimalPlaces--;
    
                while (decimalPlaces - zeroCount > 0) {
                    timeString += "0";
                    zeroCount++;
                }

                if (zeroCount > decimalPlaces) {
                    timeString = timeString.toString().substring(0, periodIndex + 3);
                }

                run.displayValue = timeString;
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/pages/staff/rodeo/photos/photo-upload.ts